<form [formGroup]="siteGroupForm">

    <ng-container *ngIf="loading">
        <acabim-loading-view></acabim-loading-view>
    </ng-container>

    <ng-container *ngIf="!loading">
        <input type="hidden" formControlName="siteGroupId" id="site-group-id">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Site group name</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" formControlName="siteGroupName" id="site-group-name" placeholder="Enter a site group name">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>

        <p-footer class="cas-form-footer">
            <div class="cas-action-buttons">
                <button class="cas-button-action" (click)="onSiteGroupUpdateSubmit()">Update</button>
                <button (click)="onCancel()">Cancel</button>
            </div>
        </p-footer>
    </ng-container>

</form>

